const chapter = {
  id: 'biomolecules-class11',
  slug: 'biomolecules-class11',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Biomolecules (Class 11)',
        hindi: 'जैव अणु (कक्षा 11)',
  },
  estReadMinutes: 55,
  difficulty: {
    english: 'Medium',
        hindi: 'मध्यम',
  },
  weightage: {
    english: '3 questions in NEET',
        hindi: 'NEET में 3 प्रश्न दो व्यापक प्रकार: **मेरिस्टेमेटिक** (विभाजन) + **स्थायी** (कोई विभाजन नहीं)। **मेरिस्टेम्स**:',
  },
  syllabusTags: ['Cell Structure & Function', 'NEET', 'Class-11'],
  sections: [
    {
      id: 'analysis',
      title: {
        english: 'Chemical Analysis & Composition',
        hindi: 'रासायनिक विश्लेषण और संघटन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Most abundant chemical in living tissues = **water (70-90 %)**.',
        hindi: 'जीवित प्राणियों में सबसे प्रचुर मात्रा में पाया जाने वाला रसायन tissues = **water (70-90 %)**।',
            },
            {
              english: 'Living tissue contains: water + acid-soluble pool (**micromolecules**: amino acids, sugars, nucleotides — MW < 1000) + acid-insoluble pool (**macromolecules**: proteins, polysaccharides, nucleic acids, lipids — MW > 10,000; lipids appear here even though small, due to membrane association).',
        hindi: 'जीवित ऊतक में शामिल हैं: पानी + एसिड-घुलनशील पूल (**माइक्रोमोलेक्यूल्स**: अमीनो एसिड, शर्करा, न्यूक्लियोटाइड्स - मेगावाट <1000) + एसिड-अघुलनशील पूल (**मैक्रोमोलेक्यूल्स**: प्रोटीन, पॉलीसेकेराइड, न्यूक्लिक एसिड, लिपिड - मेगावाट> 10,000; झिल्ली संघ के कारण लिपिड छोटे होते हुए भी यहां दिखाई देते हैं)।',
            },
            {
              english: 'Elemental abundance in living organisms (% of dry wt): H > C > O > N (also S, P, Ca, K).',
        hindi: 'जीवित जीवों में मौलिक प्रचुरता (शुष्क भार का%): H > C > O > N (S, P, Ca, K भी)।',
            },
            {
              english: '**Average molecular weights**: amino acids ~ 100; nucleotides ~ 300; sugars ~ 180; proteins/polysaccharides/NA = polymers.',
        hindi: '**औसत आणविक भार**: अमीनो एसिड ~ 100; न्यूक्लियोटाइड्स ~ 300; शर्करा ~ 180; proteins/polysaccharides/NA = polymers.',
            },
          ],
        },
      ],
    },
    {
      id: 'amino-acids-proteins',
      title: {
        english: 'Amino Acids & Proteins',
        hindi: 'ऐमीनो अम्ल और प्रोटीन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Amino acids = substituted methanes; **4 groups on α-C**: -H, -NH₂, -COOH, -R (variable side chain).',
        hindi: 'अमीनो एसिड = प्रतिस्थापित मीथेन; **α-C पर 4 समूह**: -H, -NH₂, -COOH, -R (परिवर्तनीय पार्श्व श्रृंखला)।',
            },
            {
              english: '**20 standard amino acids** in proteins; 9 essential (cannot be synthesised by humans).',
        hindi: '**प्रोटीन में 20 मानक अमीनो एसिड**; 9 आवश्यक (मानव द्वारा संश्लेषित नहीं किया जा सकता)।',
            },
            {
              english: 'Classification by R-group:',
        hindi: 'आर-समूह द्वारा वर्गीकरण:',
            },
            {
              english: '• Acidic — Glu, Asp.',
        hindi: '• अम्लीय - ग्लू, एएसपी।',
            },
            {
              english: '• Basic — Lys, Arg, His.',
        hindi: '• बेसिक - लिस, आर्ग, हिज़।',
            },
            {
              english: '• Neutral — Gly, Ala, Val, etc.',
        hindi: '• न्यूट्रल - ग्लाइ, अला, वैल, आदि।',
            },
            {
              english: '• Aromatic — Tyr, Phe, Trp.',
        hindi: '• सुगंधित - टायर, पीएचई, टीआरपी।',
            },
            {
              english: '**Zwitterion** form near isoelectric pH — both ionisable groups (-NH₃⁺, -COO⁻) charged.',
        hindi: '**Zwitterion** आइसोइलेक्ट्रिक पीएच के पास बनता है - दोनों आयनीकरण योग्य समूह (-NH₃⁺, -COO⁻) चार्ज होते हैं।',
            },
            {
              english: '**Proteins = polypeptides** (heteropolymers); **peptide bond** = -CO-NH- formed by dehydration.',
        hindi: '**Proteins = polypeptides** (heteropolymers); **पेप्टाइड बंधन** = -CO-NH- निर्जलीकरण द्वारा बनता है। **पशु जगत में सर्वाधिक प्रचुर प्रोटीन** = **कोलेजन**; **जीवमंडल में सबसे प्रचुर प्रोटीन** = **RuBisCO**।',
            },
            {
              english: '**Most abundant protein in animal world** = **collagen**; **most abundant protein in biosphere** = **RuBisCO**.',
        hindi: '**पशु जगत में सर्वाधिक प्रचुर प्रोटीन** = **कोलेजन**; **जीवमंडल में सबसे प्रचुर प्रोटीन** = **RuBisCO**।',
            },
            {
              english: 'Examples & functions: collagen (intercellular ground), trypsin (enzyme), insulin (hormone), antibody (defence), receptor (signalling), GLUT-4 (transport).',
        hindi: 'उदाहरण और कार्य: कोलेजन (इंटरसेलुलर ग्राउंड), ट्रिप्सिन (एंजाइम), इंसुलिन (हार्मोन), एंटीबॉडी (रक्षा), रिसेप्टर (सिग्नलिंग), GLUT-4 (परिवहन)।',
            },
            {
              english: 'Protein structure (4 levels):',
        hindi: 'प्रोटीन संरचना (4 स्तर):',
            },
            {
              english: '• **Primary** — sequence of amino acids; first AA = N-terminal.',
        hindi: '• **प्राथमिक** — अमीनो एसिड का अनुक्रम; पहला AA = N-terminal.',
            },
            {
              english: '• **Secondary** — α-helix / β-pleated sheet (H-bonds between backbone).',
        hindi: '• **सेकेंडरी** — α-हेलिक्स / β-प्लीटेड शीट (रीढ़ की हड्डी के बीच H-बॉन्ड)।',
            },
            {
              english: '• **Tertiary** — 3D fold (hollow ball); functional shape.',
        hindi: '• **तृतीयक** — 3डी फ़ोल्ड (खोखली गेंद); कार्यात्मक आकार.',
            },
            {
              english: '• **Quaternary** — assembly of subunits (Hb = 2α + 2β).',
        hindi: '• **चतुर्थक** — उपइकाइयों का संयोजन (Hb = 2α + 2β)। **कार्बोहाइड्रेट** — पॉलीहाइड्रॉक्सी Hb = 2α + 2β)।',
            },
          ],
        },
      ],
    },
    {
      id: 'carbo-lipid',
      title: {
        english: 'Carbohydrates & Lipids',
        hindi: 'कार्बोहाइड्रेट और लिपिड',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Carbohydrates** — polyhydroxy aldehydes/ketones.',
        hindi: '**कार्बोहाइड्रेट** - पॉलीहाइड्रॉक्सी aldehydes/ketones।',
            },
            {
              english: '• Monosaccharides — glucose, fructose, ribose.',
        hindi: '• मोनोसेकेराइड - ग्लूकोज, फ्रुक्टोज, राइबोस।',
            },
            {
              english: '• Disaccharides — sucrose (glu+fru), maltose (glu+glu), lactose (glu+gal).',
        hindi: '• डिसैकेराइड्स - सुक्रोज (ग्लू+फ्रू), माल्टोज़ (ग्लू+ग्लू), लैक्टोज (ग्लू+गैल)।',
            },
            {
              english: '• Polysaccharides (homo) — **starch** (storage in plants — α-1,4 + α-1,6 branches; iodine → blue), **glycogen** (animal storage — more branched; iodine → red), **cellulose** (β-1,4 glucose, structural cell wall, no helix).',
        hindi: '• पॉलीसेकेराइड (होमो) - **स्टार्च** (पौधों में भंडारण - α-1,4 + α-1,6 शाखाएं; आयोडीन → नीला), **ग्लाइकोजन** (पशु भंडारण - अधिक शाखायुक्त; आयोडीन → लाल), **सेलूलोज़** (β-1,4 ग्लूकोज, संरचनात्मक कोशिका दीवार, कोई हेलिक्स नहीं)।',
            },
            {
              english: '• Heteropolysaccharides — chitin (fungal wall, arthropod exoskeleton; N-acetyl glucosamine), glycosaminoglycans (hyaluronic acid).',
        hindi: '• हेटेरोपॉलीसेकेराइड - चिटिन (कवक दीवार, आर्थ्रोपॉड एक्सोस्केलेटन; एन-एसिटाइल ग्लूकोसामाइन), ग्लाइकोसामिनोग्लाइकेन्स (हयालूरोनिक एसिड)। **लिपिड** - आम तौर पर पानी में अघुलनशील (एसिड-घुलनशील पूल, लेकिन मैक्रोमोलेक्यूल्स के रूप में गिना जाता है)।',
            },
            {
              english: '**Lipids** — generally water insoluble (acid-soluble pool, but counted as macromolecules).',
        hindi: '**लिपिड** - आम तौर पर पानी में अघुलनशील (एसिड-घुलनशील पूल, लेकिन मैक्रोमोलेक्यूल्स के रूप में गिना जाता है)।',
            },
            {
              english: '• Simple — fats, oils (triglycerides = 1 glycerol + 3 fatty acids; saturated/unsaturated).',
        hindi: '• सरल - वसा, तेल (ट्राइग्लिसराइड्स = 1 ग्लिसरॉल + 3 फैटी एसिड; संतृप्त/असंतृप्त)।',
            },
            {
              english: '• Compound — phospholipids (membrane; lecithin), glycolipids.',
        hindi: '• यौगिक - फॉस्फोलिपिड्स (झिल्ली; लेसिथिन), ग्लाइकोलिपिड्स।',
            },
            {
              english: '• Derived — steroids (cholesterol → bile salts, hormones), waxes.',
        hindi: '• व्युत्पन्न - स्टेरॉयड (कोलेस्ट्रॉल → पित्त लवण, हार्मोन), मोम।',
            },
            {
              english: 'Phospholipids form **bilayer** in cell membranes (amphipathic).',
        hindi: 'फॉस्फोलिपिड कोशिका झिल्लियों (एम्फीपैथिक) में **बाईलेयर** बनाते हैं। **न्यूक्लियोटाइड्स** के पॉलिमर = नाइट्रोजन बेस + पेंटोस शुगर + फॉस्फेट।',
            },
          ],
        },
      ],
    },
    {
      id: 'nucleic-acids',
      title: {
        english: 'Nucleic Acids',
        hindi: 'न्यूक्लिक अम्ल',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Polymers of **nucleotides** = nitrogen base + pentose sugar + phosphate.',
        hindi: '**न्यूक्लियोटाइड्स** के पॉलिमर = नाइट्रोजन बेस + पेंटोस शुगर + फॉस्फेट।',
            },
            {
              english: 'Bases — Purines (**A, G**) | Pyrimidines (**C, T, U**).',
        hindi: 'क्षार - प्यूरीन (**ए, जी**) | पाइरिमिडाइन्स (**सी, टी, यू**)।',
            },
            {
              english: 'DNA = deoxyribose + A, G, C, **T**; RNA = ribose + A, G, C, **U**.',
        hindi: 'डीएनए = डीऑक्सीराइबोज़ + ए, जी, सी, **टी**; आरएनए = राइबोस + ए, जी, सी, **यू**।',
            },
            {
              english: 'Phosphodiester (3\'-5\') bonds form backbone.',
        hindi: 'फॉस्फोडिएस्टर (3\\\'-5\\\') बांड रीढ़ की हड्डी बनाते हैं।',
            },
            {
              english: 'DNA — **double helix (Watson-Crick, 1953)** — antiparallel strands; A=T (2 H-bonds), G≡C (3 H-bonds); diameter 20 Å; 10 bp/turn; pitch 34 Å.',
        hindi: 'डीएनए - **डबल हेलिक्स (वाटसन-क्रिक, 1953)** - एंटीपैरलल स्ट्रैंड्स; A=T (2 H-bonds), G≡C (3 H-बॉन्ड); व्यास 20 Å; 10 bp/turn; पिच 34 Å.',
            },
            {
              english: 'RNA — usually single-stranded; mRNA, tRNA, rRNA.',
        hindi: 'आरएनए - आमतौर पर एकल-फंसे; एमआरएनए, टीआरएनए, आरआरएनए।',
            },
          ],
        },
      ],
    },
    {
      id: 'enzymes',
      title: {
        english: 'Enzymes',
        hindi: 'एन्ज़ाइम',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Almost all enzymes are **proteins**; some are **RNA = ribozymes** (Cech).',
        hindi: 'लगभग सभी एंजाइम **प्रोटीन** हैं; कुछ **RNA = ribozymes** (Cech) हैं।',
            },
            {
              english: 'Catalyse reactions by lowering **activation energy** via formation of enzyme-substrate complex; reaction proceeds through a **transition state**.',
        hindi: 'एंजाइम-सब्सट्रेट कॉम्प्लेक्स के गठन के माध्यम से **सक्रियण ऊर्जा** को कम करके प्रतिक्रियाओं को उत्प्रेरित करें; प्रतिक्रिया **संक्रमण अवस्था** से होकर आगे बढ़ती है।',
            },
            {
              english: 'Active site — pocket where substrate binds; **lock-and-key** (Fischer) or **induced fit** (Koshland).',
        hindi: 'सक्रिय साइट - पॉकेट जहां सब्सट्रेट बांधता है; **ताला और चाबी** (फिशर) या **प्रेरित फिट** (कोशलैंड)।',
            },
            {
              english: 'Factors affecting enzyme rate:',
        hindi: 'एंजाइम दर को प्रभावित करने वाले कारक:',
            },
            {
              english: '• **Temperature** — optimum (~ 37 °C in humans); high T denatures.',
        hindi: '• **तापमान** — इष्टतम (मनुष्यों में ~ 37 डिग्री सेल्सियस); उच्च टी विकृतीकरण।',
            },
            {
              english: '• **pH** — optimum (pepsin pH 2; trypsin pH 8.5).',
        hindi: '• **pH** — इष्टतम (पेप्सिन pH 2; ट्रिप्सिन pH 8.5)।',
            },
            {
              english: '• **Substrate concentration** — Michaelis-Menten (rate ↑ then plateaus at $V_{max}$); $K_m$ = [S] at $V_{max}/2$.',
        hindi: '• **सब्सट्रेट सांद्रण** — माइकलिस-मेंटेन (दर ↑ फिर $V_{max}$ पर पठार); $K_m$ = [S] $V_{max}/2$ पर।',
            },
            {
              english: '**Enzyme inhibition**:',
        hindi: '**एंजाइम निषेध**:',
            },
            {
              english: '• **Competitive** — inhibitor structurally similar to substrate (e.g. **malonate** vs succinate for succinate dehydrogenase). $V_{max}$ unchanged; $K_m$ ↑.',
        hindi: '• **प्रतिस्पर्धी** - अवरोधक संरचनात्मक रूप से सब्सट्रेट के समान है (उदाहरण के लिए **मैलोनेट** बनाम सक्सिनेट डिहाइड्रोजनेज के लिए सक्सिनेट)। $V_{max}$ अपरिवर्तित; $K_m$ ↑.',
            },
            {
              english: '• **Non-competitive** — binds elsewhere; $V_{max}$ ↓.',
        hindi: '• **गैर-प्रतिस्पर्धी** - कहीं और बांधता है; $V_{max}$ ↓.',
            },
            {
              english: '**Cofactors** — non-protein components needed for activity:',
        hindi: '**सहकारक** — गतिविधि के लिए आवश्यक गैर-प्रोटीन घटक:',
            },
            {
              english: '• **Prosthetic group** — tightly bound (haem in catalase/peroxidase).',
        hindi: '• **प्रोस्थेटिक समूह** - कसकर बंधा हुआ (catalase/peroxidase में हेम)।',
            },
            {
              english: '• **Coenzyme** — loosely bound, often vitamins (NAD⁺ from niacin; FAD from B₂).',
        hindi: '• **कोएंजाइम** - शिथिल रूप से बंधे, अक्सर विटामिन (नियासिन से NAD⁺; B₂ से FAD)।',
            },
            {
              english: '• **Metal ions** — Zn²⁺ (carboxypeptidase), Mg²⁺ (kinases).',
        hindi: '• **धातु आयन** — Zn²⁺ (कार्बोक्सिपेप्टिडेज़), Mg²⁺ (किनेसेस)।',
            },
            {
              english: '**6 classes of enzymes** (IUBMB): **Oxidoreductases, Transferases, Hydrolases, Lyases, Isomerases, Ligases**.',
        hindi: '**एंजाइमों के 6 वर्ग** (आईयूबीएमबी): **ऑक्सीडोरडक्टेस, ट्रांसफरेज, हाइड्रॉलेज, लाइसेस, आइसोमेरेसेस, लिगेजेस**।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Most abundant protein: animal = collagen; biosphere = RuBisCO}',
      desc: {
        english: '',
        hindi: 'सर्वाधिक प्रचुर प्रोटीन: पशु = कोलेजन; जीवमंडल = रूबिस्को',
      },
    },
    {
      latex: '\\text{Peptide bond: -CO-NH- (dehydration)}',
      desc: {
        english: '',
        hindi: 'पेप्टाइड बंधन: -CO-NH- (निर्जलीकरण)',
      },
    },
    {
      latex: '\\text{Starch} \\to \\text{blue with iodine; Glycogen} \\to \\text{red}',
      desc: {
        english: '',
        hindi: 'आयोडीन के साथ स्टार्च नीला; ग्लाइकोजन लाल',
      },
    },
    {
      latex: '\\text{DNA: A=T (2 H-bonds), G}\\equiv\\text{C (3 H-bonds); 10 bp/turn; 34 Å}',
      desc: {
        english: '',
        hindi: 'डीएनए: ए=टी (2 एच-बॉन्ड), जी (3 एच-बॉन्ड); 10 बीपी/टर्न; 34 Å',
      },
    },
    {
      latex: 'V = \\dfrac{V_{max}\\,[S]}{K_m + [S]}',
      desc: {
        english: 'Michaelis-Menten',
        hindi: 'माइकलिस-मेंटेन',
      },
    },
    {
      latex: '\\text{Competitive inhibition:} \\uparrow K_m, V_{max} \\text{ same}',
      desc: {
        english: '',
        hindi: 'प्रतिस्पर्धी निषेध: K m, V अधिकतम समान',
      },
    },
    {
      latex: '\\text{6 enzyme classes: Oxidoreductase, Transferase, Hydrolase, Lyase, Isomerase, Ligase}',
      desc: {
        english: '',
        hindi: '6 एंजाइम वर्ग: ऑक्सीडोरडक्टेज़, ट्रांसफ़रेज़, हाइड्रॉलेज़, लाइसेज़, आइसोमेरेज़, लिगेज़',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Protein',
      problem: {
        english: 'Most abundant protein in animal world is:',
        hindi: 'प्राणी जगत में सर्वाधिक प्रचुर मात्रा में पाया जाने वाला प्रोटीन है:',
      },
      answer: {
        english: 'Collagen',
        hindi: 'कोलेजन',
      },
      solution: {
        english: 'Most abundant in biosphere = RuBisCO.',
        hindi: 'biosphere = RuBisCO में सर्वाधिक प्रचुर मात्रा में।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Enzyme',
      problem: {
        english: 'Malonate is a competitive inhibitor of:',
        hindi: 'मैलोनेट एक प्रतिस्पर्धी अवरोधक है:',
      },
      answer: {
        english: 'Succinate dehydrogenase',
        hindi: 'सक्सिनेट डिहाइड्रोजनेज',
      },
      solution: {
        english: 'Structurally similar to succinate.',
        hindi: 'संरचनात्मक रूप से सक्सिनेट के समान।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Polysaccharide',
      problem: {
        english: 'Glycogen on hydrolysis gives:',
        hindi: 'हाइड्रोलिसिस पर ग्लाइकोजन देता है:',
      },
      answer: {
        english: 'Glucose units',
        hindi: 'ग्लूकोज इकाइयाँ',
      },
      solution: {
        english: 'Highly branched α-1,4 + α-1,6.',
        hindi: 'अत्यधिक शाखायुक्त α-1,4 + α-1,6।',
      },
    },
    {
      year: 2020,
      exam: 'NEET',
      tag: 'DNA',
      problem: {
        english: 'In B-form DNA, number of base pairs per turn:',
        hindi: 'बी-फॉर्म डीएनए में, प्रति मोड़ आधार जोड़े की संख्या:',
      },
      answer: {
        english: '10',
        hindi: '10',
      },
      solution: {
        english: 'Pitch 34 Å; 3.4 Å between adjacent bases.',
        hindi: 'पिच 34 Å; आसन्न आधारों के बीच 3.4 Å।',
      },
    },
    {
      year: 2019,
      exam: 'NEET',
      tag: 'Coenzyme',
      problem: {
        english: 'NAD⁺ acts as a coenzyme; its vitamin precursor is:',
        hindi: 'NAD⁺ एक कोएंजाइम के रूप में कार्य करता है; इसका विटामिन अग्रदूत है:',
      },
      answer: {
        english: 'Niacin (B₃)',
        hindi: 'नियासिन (बी₃)',
      },
      solution: {
        english: 'FAD from riboflavin (B₂).',
        hindi: 'राइबोफ्लेविन (B₂) से FAD।',
      },
    },
  ],
  next: null,
};

export default chapter;
